import React from "react";
import styled from "styled-components";

import goLogo from "commons/src/css/images/logos/Go.png";

export function GoLogo() {
    return (
        <LogoDiv>
            <Logo src={goLogo} />
        </LogoDiv>
    );
}

export const LogoDiv = styled.div`
    text-align: center;
`;

const Logo = styled.img`
    max-width: 90px;
    max-height: 90px;
    margin-top: 20px;
`;
